import { arrayHasMoreThanNItems, arrayHasNItems } from "../../utils/arrayUtils";
import { CompanyTiles } from "./company-tiles";
import { useNavigate } from "react-router-dom";

export const CompanyContainer = ({ companies, showDelete, onToggleDelete  }) => {

    const navigate = useNavigate();

    if (arrayHasNItems(companies, 1)) {
        return navigate(`/company/detail/${companies[0].id}`);
    }

    return arrayHasMoreThanNItems(companies, 1) ? (

        <div className={'pos-customer'} >
            <div className="pos-content">
                <div className="pos-content-container" options={{ suppressScrollX: true }}>
                    <div className="product-row">
                        <CompanyTiles companies={companies} showDelete={showDelete} onToggleDelete={onToggleDelete} />
                    </div>
                </div>
            </div>
        </div>
    )
        :
        (
            <>No Data</>
        )
};